<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("addressbook") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right">
            <v-btn text @click="addAddress">{{ $t("add") }}</v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <v-list>
          <v-list-item three-line v-for="(addr, index) in $store.state.addressList" :key="index" @click="select(addr)">
            <v-list-item-content>
              <div class="address-container">
                <div>
                  <v-list-item-title>{{ addr.name }}</v-list-item-title>
                  <v-list-item-subtitle v-html="addressToComponent(addr)"> </v-list-item-subtitle>
                  <!--                   <v-list-item-subtitle
                    ><span v-if="addr.unit != null && addr.unit != ''">Unit {{ addr.unit }}, </span
                    >{{ addr.street }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle>{{ addr.city }}</v-list-item-subtitle> -->
                </div>
                <v-menu bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
                  </template>

                  <v-list>
                    <v-list-item>
                      <v-list-item-title @click="editAddress(index)">{{ $t("edit") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="defaultAddress(addr)">{{ $t("default") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="deleteAddress(index)" style="color:var(--v-warning-base)">{{
                        $t("delete")
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <AddressDialog ref="addressDialog"></AddressDialog>
  </v-dialog>
</template>

<script>
import AddressDialog from "@/dialogs/AddressDialog";

export default {
  components: {
    AddressDialog,
  },

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
  }),

  created() {},

  computed: {},

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(null);
      this.dialog = false;
    },

    addressToComponent(address) {
      let comp = "";
      if (address != null) {
        let line1 = "";
        let line2 = "";
        if (address.unit != null && address.unit != "") line1 += "Unit " + address.unit;
        if (address.street != null && address.street != "") line1 += (line1 == "" ? "" : ", ") + address.street;

        if (address.city != null && address.city != "") line2 += address.city;
        if (address.province != null && address.province != "") line2 += (line2 == "" ? "" : ", ") + address.province;
        if (address.postal != null && address.postal != "") line2 += (line2 == "" ? "" : ", ") + address.postal;

        comp = line1 + (line2 == "" ? "" : "<br>") + line2;
      }

      return comp;
    },

    addAddress() {
      this.$refs.addressDialog.open().then(n_addr => {
        if (n_addr != null) {
          this.$store.state.addressList.push(n_addr);
          this.saveAddressList();
        }
      });
    },

    editAddress(index) {
      let addr = this.$store.state.addressList[index];
      this.$refs.addressDialog.open(addr).then(n_addr => {
        console.log(n_addr);
        if (n_addr != null) {
          this.$set(this.$store.state.addressList, index, n_addr);
          this.saveAddressList();
        }
      });
    },

    deleteAddress(index) {
      this.$store.state.addressList.splice(index, 1);
      this.saveAddressList();
    },

    defaultAddress(address) {
      this.moveAddressToFirst(address);
      this.saveAddressList();
    },

    async select(addr) {
      if (this.$router.currentRoute.name == "Checkout") {
        let showDeliveryCharge = this.$devEnv;

        let quote = await this.getDeliveryQuote(addr);
        if (quote.result == "ok") {
          let deliveryAddressString = this.addressToString(quote.address);
          let message = this.$t("confirm_delivery_message", {
            delivery_address: deliveryAddressString,
          });
          if (quote.deliveryValue > 0 && showDeliveryCharge) {
            message = this.$t("confirm_delivery_with_charge_message", {
              delivery_address: deliveryAddressString,
              delivery_value: quote.deliveryValue,
            });
          }

          this.$root.confirmDialog(this.$t("confirm_title"), "", message).then(resp => {
            if (resp) {
              this.resolve(addr);
              this.dialog = false;
            }
          });
        } else if (quote.error != null) {
          let errorMessage = quote.error;
          let errorCode = quote.errorCode;
          if (errorCode != null && errorCode != "") errorMessage = this.$t("faceDrive.error." + errorCode);
          this.$root.messageDialog(this.$t("error_address"), "", errorMessage);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.address-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
